export const countries = [
  { id: 1, label: "Việt Nam (VND đ)", value: "VND" },
  { id: 2, label: "United States (USD $)", value: "USD" },
  { id: 3, label: "France (EUR €)", value: "EUR" },
  { id: 4, label: "Romania (RON Lei)", value: "RON" },
  { id: 5, label: "Russia (RUB ₽)", value: "RUB" },
  { id: 6, label: "Saudi Arabia (SAR ر.س)", value: "SAR" },
  { id: 7, label: "Spain (EUR €)", value: "EUR" },
];
export const languages = [
  { id: 1, label: "Tiếng Việt", value: "vi-VN" },
  { id: 2, label: "English", value: "en-US" },
  { id: 3, label: "Français", value: "fr-FR" },
  { id: 4, label: "Română", value: "ro-RO" },
  { id: 5, label: "Русский", value: "ru-RU" },
  { id: 6, label: "السعودية", value: "ar-SA" },
  { id: 7, label: "Españo", value: "es-ES" },
];
export const sampleProducts =[
  // {
  //     "_id": "6874b087cb75257a86982f1d",
  //     "name": "CVF Lẩu Tri Kỷ",
  //     "image": {
  //         "public_id": "ShoeShop/tllftv830rkwmnqaedna",
  //         "url": "https://res.cloudinary.com/dw8zlil8k/image/upload/v1752477812/ShoeShop/tllftv830rkwmnqaedna.jpg"
  //     },
  //     "arrImage": [
  //         {
  //             "url": "https://res.cloudinary.com/dw8zlil8k/image/upload/v1752477823/ShoeShop/bubr6gq52pcsg1ewv5rp.jpg",
  //             "public_id": "ShoeShop/bubr6gq52pcsg1ewv5rp",
  //             "_id": "6874b087cb75257a86982f1e"
  //         },
  //         {
  //             "url": "https://res.cloudinary.com/dw8zlil8k/image/upload/v1752477824/ShoeShop/d5mxorhgjkblcl88qjo5.jpg",
  //             "public_id": "ShoeShop/d5mxorhgjkblcl88qjo5",
  //             "_id": "6874b087cb75257a86982f1f"
  //         },
  //         {
  //             "url": "https://res.cloudinary.com/dw8zlil8k/image/upload/v1752477825/ShoeShop/rrxy4yl4505iete4r1dc.jpg",
  //             "public_id": "ShoeShop/rrxy4yl4505iete4r1dc",
  //             "_id": "6874b087cb75257a86982f20"
  //         },
  //         {
  //             "url": "https://res.cloudinary.com/dw8zlil8k/image/upload/v1752477826/ShoeShop/dfmrvhi0o4ndrvvz5mmw.jpg",
  //             "public_id": "ShoeShop/dfmrvhi0o4ndrvvz5mmw",
  //             "_id": "6874b087cb75257a86982f21"
  //         }
  //     ],
  //     "description": "Set Lẩu Lòng bò Tri Kỷ (195k) – Trọn Vẹn Hương Vị Bắc Bộ, Tiện Lợi Mọi Lúc\n\n✨ Thành phần hấp dẫn:\n\nNhân lòng (500g): Bao gồm lòng béo, tổ ong, dạ dày, gân vó, sụn bò, lá khế, bò viên. Được hầm chín trong 1 giờ đồng hồ\nNước lẩu (1500g): Đậm đà, được hầm chín từ 100% xương ống bò trong 10 giờ đồng hồ, mang hương vị chuẩn truyền thống Chợ Viềng.\nGói thuốc bắc bổ dưỡng: Đông trùng hạ thảo, Kỷ tử, Táo đỏ, Bạch chỉ, Thục địa, Xuyên khung (Tăng cường dinh dưỡng, thơm ngon tự nhiên).\nNước chấm pha sẵn: Vừa vặn, đậm đà, không cần thêm bớt, phù hợp với mọi khẩu vị.\n\n✨ Thành phần dinh dưỡng: Năng lượng 125kcal/ 100g; Đạm/ Protein 7.01g/ 100g; Béo tổng hợp 10.3 g/ 100g; Carbohydrat 1g/ 100g; Natri/ Sodium 442mg/ 100g",
  //     "country": [],
  //     "rating": 5,
  //     "numReviews": 1,
  //     "category": "67ceda8a3d3c27069aec431c",
  //     "price": 7.36,
  //     "countInStock": 19,
  //     "sold": 1,
  //     "reviews": [
  //         {
  //             "name": "thachtu",
  //             "rating": 5,
  //             "comment": "Lẩu ngon hương vị đậm đà, sẽ quay lại",
  //             "user": "68874e8b4417523f3aedbfca",
  //             "_id": "68874ec44417523f3aedbfec"
  //         }
  //     ],
  //     "createdAt": "2025-07-14T07:23:51.626Z",
  //     "updatedAt": "2025-07-28T10:19:48.028Z",
  //     "__v": 1
  // },
  // {
  //     "_id": "6874b00acb75257a86982f0b",
  //     "name": "CVF Lẩu Tâm Giao",
  //     "image": {
  //         "public_id": "ShoeShop/t6hsncydrp7wd55ow1zq",
  //         "url": "https://res.cloudinary.com/dw8zlil8k/image/upload/v1752477692/ShoeShop/t6hsncydrp7wd55ow1zq.jpg"
  //     },
  //     "arrImage": [
  //         {
  //             "url": "https://res.cloudinary.com/dw8zlil8k/image/upload/v1752477699/ShoeShop/ogqtqm2xwyytomkixplr.jpg",
  //             "public_id": "ShoeShop/ogqtqm2xwyytomkixplr",
  //             "_id": "6874b00acb75257a86982f0c"
  //         },
  //         {
  //             "url": "https://res.cloudinary.com/dw8zlil8k/image/upload/v1752477700/ShoeShop/q2p7qap1yercrvlwe9hm.jpg",
  //             "public_id": "ShoeShop/q2p7qap1yercrvlwe9hm",
  //             "_id": "6874b00acb75257a86982f0d"
  //         },
  //         {
  //             "url": "https://res.cloudinary.com/dw8zlil8k/image/upload/v1752477701/ShoeShop/rkvxbdlxvftxrvopilu8.jpg",
  //             "public_id": "ShoeShop/rkvxbdlxvftxrvopilu8",
  //             "_id": "6874b00acb75257a86982f0e"
  //         },
  //         {
  //             "url": "https://res.cloudinary.com/dw8zlil8k/image/upload/v1752477702/ShoeShop/rdmi8s46rlnxwjcllvil.jpg",
  //             "public_id": "ShoeShop/rdmi8s46rlnxwjcllvil",
  //             "_id": "6874b00acb75257a86982f0f"
  //         }
  //     ],
  //     "description": "Set Lẩu Lòng bò Tâm Giao (270k) – Hương Vị Truyền Thống, Trọn Vẹn Niềm Vui\n\n✨ Thành phần hấp dẫn:\n\nNhân lòng (800g): Bao gồm lòng béo, tổ ong, dạ dày, gân vó, sụn bò, lá khế, bò viên. Được hầm chín trong 1 giờ đồng hồ\nNước lẩu (1500g): Hầm chín từ 100% xương ống bò trong 10 giờ, đậm đà và thơm ngon chuẩn vị Chợ Viềng.\nGói thuốc bắc bổ dưỡng: Đông trùng hạ thảo, Kỷ tử, Táo đỏ, Bạch chỉ, Thục địa, Xuyên khung (Gia tăng giá trị dinh dưỡng và hương vị độc đáo).\nNước chấm pha sẵn: Vừa miệng, không cần thêm gia vị, phù hợp với mọi khẩu vị.\n✨ Thành phần dinh dưỡng: Năng lượng 125kcal/ 100g; Đạm/ Protein 7.01g/ 100g; Béo tổng hợp 10.3 g/ 100g; Carbohydrat 1g/ 100g; Natri/ Sodium 442mg/ 100g",
  //     "country": [
  //         {
  //             "name": "Vietnam",
  //             "symbol": "VN",
  //             "_id": "6874b00acb75257a86982f10"
  //         }
  //     ],
  //     "rating": 0,
  //     "numReviews": 0,
  //     "category": "67ceda8a3d3c27069aec431c",
  //     "price": 10.19,
  //     "countInStock": 43,
  //     "sold": 1,
  //     "reviews": [],
  //     "createdAt": "2025-07-14T07:21:46.292Z",
  //     "updatedAt": "2025-07-16T09:09:19.938Z",
  //     "__v": 0
  // },
  // {
  //     "_id": "6874afa5cb75257a86982ef1",
  //     "name": "CVF Lẩu Tình Thân",
  //     "image": {
  //         "public_id": "ShoeShop/qneuci9h1i7h4aami9ya",
  //         "url": "https://res.cloudinary.com/dw8zlil8k/image/upload/v1752477566/ShoeShop/qneuci9h1i7h4aami9ya.jpg"
  //     },
  //     "arrImage": [
  //         {
  //             "url": "https://res.cloudinary.com/dw8zlil8k/image/upload/v1752477582/ShoeShop/vagupi10binyk2bcurvo.jpg",
  //             "public_id": "ShoeShop/vagupi10binyk2bcurvo",
  //             "_id": "6874afa5cb75257a86982ef2"
  //         },
  //         {
  //             "url": "https://res.cloudinary.com/dw8zlil8k/image/upload/v1752477584/ShoeShop/labtyresu6ciumvyjn1b.jpg",
  //             "public_id": "ShoeShop/labtyresu6ciumvyjn1b",
  //             "_id": "6874afa5cb75257a86982ef3"
  //         },
  //         {
  //             "url": "https://res.cloudinary.com/dw8zlil8k/image/upload/v1752477585/ShoeShop/tcgrbcsdxjvm67ablcij.jpg",
  //             "public_id": "ShoeShop/tcgrbcsdxjvm67ablcij",
  //             "_id": "6874afa5cb75257a86982ef4"
  //         },
  //         {
  //             "url": "https://res.cloudinary.com/dw8zlil8k/image/upload/v1752477586/ShoeShop/ho64d140kagpuxhnqqfy.jpg",
  //             "public_id": "ShoeShop/ho64d140kagpuxhnqqfy",
  //             "_id": "6874afa5cb75257a86982ef5"
  //         }
  //     ],
  //     "description": "Set Lẩu Lòng Bò Tình Thân (380k) – Trọn Vẹn Hương Vị, Kết Nối Yêu Thương\n\n✨ Thành phần hấp dẫn:\n\nNhân lòng (800g): Bao gồm lòng béo, tổ ong, dạ dày, gân vó, sụn bò, lá khế, bò viên. Đã được hầm chín trong 1 giờ đồng hồ\nĐuôi bò (300g): Ngọt mềm, tăng thêm hương vị đậm đà cho nồi lẩu.\nNước lẩu (1500g): Hầm chín từ 100% xương ống bò trong 10 giờ, mang hương vị truyền thống chuẩn Bắc Bộ.\nGói thuốc bắc bổ dưỡng: Đông trùng hạ thảo, Kỷ tử, Táo đỏ, Bạch chỉ, Thục địa, Xuyên khung (Làm giàu giá trị dinh dưỡng, tạo nên hương vị độc đáo).\nNước chấm pha sẵn: Chuẩn vị, không cần thêm nếm, làm nổi bật từng miếng lòng bò.\n✨ Thành phần dinh dưỡng: Năng lượng 125kcal/ 100g; Đạm/ Protein 7.01g/ 100g; Béo tổng hợp 10.3 g/ 100g; Carbohydrat 1g/ 100g; Natri/ Sodium 442mg/ 100g",
  //     "country": [],
  //     "rating": 5,
  //     "numReviews": 1,
  //     "category": "67ceda8a3d3c27069aec431c",
  //     "price": 14.34,
  //     "countInStock": 28,
  //     "sold": 2,
  //     "reviews": [
  //         {
  //             "name": "thachtu",
  //             "rating": 5,
  //             "comment": "Ngon và nhiều",
  //             "user": "68874e8b4417523f3aedbfca",
  //             "_id": "68874fa84417523f3aedc04f"
  //         }
  //     ],
  //     "createdAt": "2025-07-14T07:20:05.486Z",
  //     "updatedAt": "2025-07-28T10:23:36.131Z",
  //     "__v": 1
  // },
  // {
  //     "_id": "67c9cc8ab29d44f2f3977fd3",
  //     "name": "Cung cấp POS uy tín",
  //     "image": {
  //         "public_id": "ShoeShop/ewyh5lsygkibgxze3utx",
  //         "url": "https://res.cloudinary.com/dw8zlil8k/image/upload/v1741278227/ShoeShop/ewyh5lsygkibgxze3utx.jpg"
  //     },
  //     "description": "Cung cấp POS uy tín toàn quốc nhanh chóng. Các loại pos với phí siêu hấp dẫn",
  //     "country": [
  //         {
  //             "name": "Vietnam",
  //             "symbol": "VN",
  //             "_id": "67cbba303ff1497c431b65ea"
  //         }
  //     ],
  //     "rating": 0,
  //     "numReviews": 0,
  //     "category": "67c9c746b29d44f2f3977f6b",
  //     "price": 600,
  //     "countInStock": 999,
  //     "reviews": [],
  //     "createdAt": "2025-03-06T16:25:46.660Z",
  //     "updatedAt": "2025-07-16T09:09:19.844Z",
  //     "__v": 2,
  //     "arrImage": [],
  //     "sold": 525
  // },
  // {
  //     "_id": "67c9c9c0b29d44f2f3977f74",
  //     "name": "Thanh toán thẻ tín dụng",
  //     "image": {
  //         "public_id": "ShoeShop/ab0kczbboo1qeghglqaf",
  //         "url": "https://res.cloudinary.com/dw8zlil8k/image/upload/v1741277518/ShoeShop/ab0kczbboo1qeghglqaf.jpg"
  //     },
  //     "description": "Dịch vụ đáo rút thẻ tín dụng uy tín & nhanh gọn. Nhiều ưu đãi hấp dẫn",
  //     "country": [],
  //     "rating": 0,
  //     "numReviews": 0,
  //     "category": "67c9c746b29d44f2f3977f6b",
  //     "price": 0,
  //     "countInStock": 1000,
  //     "reviews": [],
  //     "createdAt": "2025-03-06T16:13:52.507Z",
  //     "updatedAt": "2025-07-14T07:07:28.885Z",
  //     "__v": 4,
  //     "arrImage": [],
  //     "sold": 1147
  // }
];


export const categories = [
  {
    id: "1",
    name: "Đồ uống",
    image: "https://demo-grocy-06.myshopify.com/cdn/shop/files/menu-cat-01.jpg?v=1720610568",
    href: "category",
  },
  {
    id: "2",
    name: "Trái cây",
    image: "https://demo-grocy-06.myshopify.com/cdn/shop/files/menu-cat-02.jpg?v=1720610568",
    href: "category",
  },
  {
    id: "3",
    name: "Kem",
    image: "https://demo-grocy-06.myshopify.com/cdn/shop/files/menu-cat-03.jpg?v=1720610568",
    href: "category",
  },
  {
    id: "4",
    name: "Kem sữa",
    image: "https://demo-grocy-06.myshopify.com/cdn/shop/files/menu-cat-04.jpg?v=1720610569",
    href: "category",
  },
  {
    id: "5",
    name: "Rau củ",
    image: "https://demo-grocy-06.myshopify.com/cdn/shop/files/menu-cat-05.jpg?v=1720610568",
    href: "category",
  },
  {
    id: "6",
    name: "Mật ong",
    image: "https://demo-grocy-06.myshopify.com/cdn/shop/files/menu-cat-06.jpg?v=1720610568",
    href: "category",
  },
  {
    id: "7",
    name: "Khoai tây",
    image: "https://demo-grocy-06.myshopify.com/cdn/shop/files/menu-cat-07.jpg?v=1720610569",
    href: "category",
  },
  {
    id: "8",
    name: "Rau chân vịt",
    image: "https://demo-grocy-06.myshopify.com/cdn/shop/files/menu-cat-08.jpg?v=1720610568",
    href: "category",
  },
];

export const menuItems = [
  { label: "Trang chủ", href: "/", isMega: false, ishome: true },

  // {
  //   label: "Cửa hàng",
  //   isMega: true,
  //   columns: [
  //     {
  //       title: "Đồ uống",
  //       items: [
  //         { label: "Nước giải khát", id: "1", href: "/category/cold-drinks" },
  //         { label: "Đồ uống có cồn", id: "2", href: "/category/beer-items" },
  //         { label: "Nước có gas", id: "3", href: "/category/carbonated" },
  //         { label: "Nước từ thực vật", id: "4", href: "/category/plant-drinks" },
  //         { label: "Nước ép", id: "5", href: "/category/juices" },
  //       ],
  //     },
  //     {
  //       title: "Sản phẩm từ sữa",
  //       items: [
  //         { label: "Bánh mì", id: "6", href: "/category/bread" },
  //         { label: "Kem", id: "7", href: "/category/ice-cream" },
  //         { label: "Bơ", id: "8", href: "/category/butter" },
  //         { label: "Bánh quy", id: "9", href: "/category/cookies" },
  //         { label: "Phô mai", id: "10", href: "/category/cheese" },
  //       ],
  //     },
  //   ],
  //   banners: [
  //     {
  //       title: "Ưu đãi",
  //       describe: "Giảm 80%",
  //       url: "",
  //       link: "https://demo-grocy-06.myshopify.com/cdn/shop/files/shop-banner-02.jpg?v=1720610522",
  //     },
  //     {
  //       title: "Ưu đãi",
  //       describe: "Giảm 80%",
  //       url: "",
  //       link: "https://demo-grocy-06.myshopify.com/cdn/shop/files/shop-banner-01.jpg?v=1720610522",
  //     },
  //   ],
  // },

  // {
  //   label: "Đặc biệt",
  //   isMega: true,
  //   badge: "GIẢM GIÁ",
  //   colection: {
  //     title: "Sản phẩm đặc biệt",
  //     products: sampleProducts,
  //     isSlider: true,
  //   },
  // },

  // {
  //   label: "Danh mục",
  //   isMega: true,
  //   badge: "HOT",
  //   columns: [
  //     {
  //       title: "Đồ uống",
  //       items: [
  //         { label: "Nước giải khát", id: "11", href: "/category/cold-drinks" },
  //         { label: "Đồ uống có cồn", id: "12", href: "/category/beer-items" },
  //         { label: "Nước có gas", id: "13", href: "/category/carbonated" },
  //         { label: "Nước từ thực vật", id: "14", href: "/category/plant-drinks" },
  //         { label: "Nước ép", id: "15", href: "/category/juices" },
  //       ],
  //     },
  //     {
  //       title: "Sản phẩm từ sữa",
  //       items: [
  //         { label: "Bánh mì", id: "16", href: "/category/bread" },
  //         { label: "Kem", id: "17", href: "/category/ice-cream" },
  //         { label: "Bơ", id: "18", href: "/category/butter" },
  //         { label: "Bánh quy", id: "19", href: "/category/cookies" },
  //         { label: "Phô mai", id: "20", href: "/category/cheese" },
  //       ],
  //     },
  //     {
  //       title: "Sản phẩm từ sữa",
  //       items: [
  //         { label: "Bánh mì", id: "21", href: "/category/bread" },
  //         { label: "Kem", id: "22", href: "/category/ice-cream" },
  //         { label: "Bơ", id: "23", href: "/category/butter" },
  //         { label: "Bánh quy", id: "24", href: "/category/cookies" },
  //         { label: "Phô mai", id: "25", href: "/category/cheese" },
  //       ],
  //     },
  //     {
  //       title: "Đồ uống",
  //       items: [
  //         { label: "Nước giải khát", id: "26", href: "/category/cold-drinks" },
  //         { label: "Đồ uống có cồn", id: "27", href: "/category/beer-items" },
  //         { label: "Nước có gas", id: "28", href: "/category/carbonated" },
  //         { label: "Nước từ thực vật", id: "29", href: "/category/plant-drinks" },
  //         { label: "Nước ép", id: "30", href: "/category/juices" },
  //       ],
  //     },
  //     {
  //       title: "Sản phẩm từ sữa",
  //       items: [
  //         { label: "Bánh mì", id: "31", href: "/category/bread" },
  //         { label: "Kem", id: "32", href: "/category/ice-cream" },
  //         { label: "Bơ", id: "33", href: "/category/butter" },
  //         { label: "Bánh quy", id: "34", href: "/category/cookies" },
  //         { label: "Phô mai", id: "35", href: "/category/cheese" },
  //       ],
  //     },
  //     {
  //       title: "Sản phẩm từ sữa",
  //       items: [
  //         { label: "Bánh mì", id: "36", href: "/category/bread" },
  //         { label: "Kem", id: "37", href: "/category/ice-cream" },
  //         { label: "Bơ", id: "38", href: "/category/butter" },
  //         { label: "Bánh quy", id: "39", href: "/category/cookies" },
  //         { label: "Phô mai", id: "40", href: "/category/cheese" },
  //       ],
  //     },
  //   ],
  //   colection: {
  //     title: "Sản phẩm đặc biệt",
  //     products: sampleProducts,
  //     isSlider: false,
  //   },
  // },

  // {
  //   isMega: true,
  //   label: "Ưu đãi hàng đầu",
  //   categories: {
  //     title: "Mua theo",
  //     items: categories.map((c, index) => ({
  //       label: c.name, // giả sử c có thuộc tính name
  //       image:c.image,
  //       id: String(100 + index),
  //       href: `/category/1`,
  //     })),
  //   },
  //   colection: {
  //     title: "Sản phẩm đặc biệt",
  //     products: sampleProducts,
  //     isSlider: false,
  //   },
  // },

  // {
  //   isMega: true,
  //   label: "Thành phần",
  //   childrens: [
  //     { label: "Nước giải khát", id: "200", href: "/category/cold-drinks" },
  //     { label: "Đồ uống có cồn", id: "201", href: "/category/beer-items" },
  //     { label: "Nước có gas", id: "202", href: "/category/carbonated" },
  //     { label: "Nước từ thực vật", id: "203", href: "/category/plant-drinks" },
  //     { label: "Nước ép", id: "204", href: "/category/juices" },
  //   ],
  // },
];


export const categoriesTrigger = [
  {
    id: 1,
    name: "Bakery",
    children: [
      { id: 11, name: "Biscuits", children: [] },
      { id: 12, name: "Cookies", children: [] },
      { id: 13, name: "Wafers", children: [] },
      { id: 14, name: "Cake", children: [] },
    ],
  },
  {
    id: 2,
    name: "Vegetables",
    children: [
      { id: 21, name: "Chips", children: [] },
      { id: 22, name: "Snacks Item", children: [] },
      { id: 23, name: "Crackers", children: [] },
      { id: 24, name: "Bars", children: [] },
      { id: 25, name: "Toasts", children: [] },
    ],
  },
  {
    id: 3,
    name: "Beverages",
    children: [
      { id: 31, name: "Cold Drinks", children: [] },
      { id: 32, name: "Beer Items", children: [] },
      { id: 33, name: "Carbonated", children: [] },
      { id: 34, name: "Plant Drinks", children: [] },
      { id: 35, name: "Juices Items", children: [] },
      { id: 36, name: "Milk Items", children: [] },
      { id: 37, name: "Coffee", children: [] },
      { id: 38, name: "Cream", children: [] },
      { id: 39, name: "Chocolate", children: [] },
      { id: 40, name: "Milk", children: [] },
    ],
  },
  {
    id: 4,
    name: "Sea Food",
    children: [
      { id: 41, name: "Meats", children: [] },
      { id: 42, name: "Chiken", children: [] },
      { id: 43, name: "Eggs", children: [] },
      { id: 44, name: "Poultry", children: [] },
    ],
  },
  {
    id: 5,
    name: "Dairy Items",
    children: [
      { id: 51, name: "Bread Items", children: [] },
      { id: 52, name: "Ice Cream", children: [] },
      { id: 53, name: "Butter Items", children: [] },
      { id: 54, name: "Cookies Items", children: [] },
      { id: 55, name: "Cheese Items", children: [] },
    ],
  },
];
export const categoriesList = [
  {
    id: "1",
    name: "Rau củ", // Vegetables
    href: "/category/vegetables",
    image: "https://demo-grocy-06.myshopify.com/cdn/shop/collections/cat-05.png?v=1720163229&width=425",
    color: "#D8F3DC",
  },
  {
    id: "2",
    name: "Trái cây", // Fruits
    href: "/category/fruits",
    image: "https://demo-grocy-06.myshopify.com/cdn/shop/collections/cat-06.png?v=1720163244&width=425",
    color: "#EDE4FF",
  },
  {
    id: "3",
    name: "Thịt", // Meats
    href: "/category/meats",
    image: "https://demo-grocy-06.myshopify.com/cdn/shop/collections/cat-02.png?v=1720163110&width=425",
    color: "#F5EBE0",
  },
  {
    id: "4",
    name: "Nước ép", // Juices
    href: "/category/juices",
    image: "https://demo-grocy-06.myshopify.com/cdn/shop/collections/cat-04.png?v=1720163432&width=425",
    color: "#E0F2FE",
  },
  {
    id: "5",
    name: "Sữa", // Milk
    href: "/category/milk",
    image: "https://demo-grocy-06.myshopify.com/cdn/shop/collections/cat-04.png?v=1720163432&width=425",
    color: "#FDE2E4",
  },
  {
    id: "6",
    name: "Bánh mì & Bánh ngọt", // Bakery
    href: "/category/bakery",
    image: "https://demo-grocy-06.myshopify.com/cdn/shop/collections/cat-01.png?v=1720163010&width=425",
    color: "#D8F3DC",
  },
];


export const sliders = [
  {
    title: "",
    describe: "",
    image: "https://ngonfood.com/images/20.png",
    action: {
      title: "Mua ngay",
      href: "#",
    },
  },
  {
    title: "",
    describe: "",
    image: "https://ngonfood.com/images/21.png",
    action: {
      title: "Mua ngay",
      href: "#",
    },
  },
];export const blogPosts = [
  {
    image: "https://demo-grocy-06.myshopify.com/cdn/shop/articles/blog-03.jpg?v=1720163764&width=720",
    date: "Ngày 5 Tháng 7, 2024",
    author: "Seenu Rawat",
    title: "Cách viết bài blog khiến độc giả yêu thích chỉ với 5 bước",
    link: "/blog/1",
  },
  {
    image: "https://demo-grocy-06.myshopify.com/cdn/shop/articles/blog-02.jpg?v=1720163715&width=720",
    date: "Ngày 10 Tháng 7, 2024",
    author: "Anna Smith",
    title: "10 ý tưởng sáng tạo để nâng cao chiến lược nội dung",
    link: "/blog/1",
  },
  {
    image: "https://demo-grocy-06.myshopify.com/cdn/shop/articles/blog-01.jpg?v=1720163558&width=720",
    date: "Ngày 12 Tháng 7, 2024",
    author: "John Doe",
    title: "Tại sao SEO vẫn quan trọng trong năm 2024: Các phương pháp hay nhất",
    link: "/blog/1",
  },
  {
    image: "https://demo-grocy-06.myshopify.com/cdn/shop/articles/blog-04.jpg?v=1720163782&width=720",
    date: "Ngày 15 Tháng 7, 2024",
    author: "Lisa Brown",
    title: "7 công cụ hàng đầu mà mọi blogger nên sử dụng",
    link: "/blog/1",
  },
  {
    image: "https://demo-grocy-06.myshopify.com/cdn/shop/articles/blog-05.jpg?v=1720163818&width=720",
    date: "Ngày 18 Tháng 7, 2024",
    author: "David Lee",
    title: "Cách xây dựng cộng đồng độc giả trung thành bằng kể chuyện",
    link: "/blog/1",
  },
  {
    image: "https://demo-grocy-06.myshopify.com/cdn/shop/articles/blog-06.jpg?v=1720163885&width=720",
    date: "Ngày 20 Tháng 7, 2024",
    author: "Maria Garcia",
    title: "Mẹo mạng xã hội để tăng lưu lượng truy cập blog",
    link: "/blog/1",
  },
  {
    image: "https://demo-grocy-06.myshopify.com/cdn/shop/articles/blog-05.jpg?v=1720163818&width=720",
    date: "Ngày 23 Tháng 7, 2024",
    author: "Chris Evans",
    title: "Hướng dẫn cho người mới bắt đầu kiếm tiền từ blog",
    link: "/blog/1",
  },
  {
    image: "https://demo-grocy-06.myshopify.com/cdn/shop/articles/blog-01.jpg?v=1720163558&width=720",
    date: "Ngày 25 Tháng 7, 2024",
    author: "Sophia Wilson",
    title: "5 mẹo thiết kế để blog của bạn trông chuyên nghiệp hơn",
    link: "/blog/1",
  },
  {
    image: "https://demo-grocy-06.myshopify.com/cdn/shop/articles/blog-01.jpg?v=1720163558&width=720",
    date: "Ngày 28 Tháng 7, 2024",
    author: "Michael Chen",
    title: "Tại sao Email Marketing lại quan trọng với blogger",
    link: "/blog/1",
  },
  {
    image: "https://demo-grocy-06.myshopify.com/cdn/shop/articles/blog-04.jpg?v=1720163782&width=720",
    date: "Ngày 30 Tháng 7, 2024",
    author: "Emma Johnson",
    title: "Tương lai của blogging: Những xu hướng cần theo dõi năm 2025",
    link: "/blog/1",
  },
];

export const footerLinks = [
  {
    title: "Chính sách cửa hàng",
    links: [
      { label: "Thông tin", href: "/information" },
      { label: "Chính sách bảo mật", href: "/privacy" },
      { label: "Hoàn tiền", href: "/refund" },
      { label: "Vận chuyển", href: "/shipping" },
      { label: "Dịch vụ", href: "/service" },
    ],
  },
  {
    title: "Liên kết nhanh",
    links: [
      { label: "Về chúng tôi", href: "/about" },
      { label: "Liên hệ", href: "/contact" },
      { label: "Câu hỏi thường gặp", href: "/faqs" },
      { label: "So sánh", href: "/compare" },
      { label: "Yêu thích", href: "/wishlist" },
    ],
  },
  {
    title: "Về chúng tôi",
    links: [
      { label: "Cửa hàng của chúng tôi", href: "/our-store" },
      // { label: "Bánh ngọt", href: "/bakery" },
      // { label: "Gà", href: "/chicken" }, // sửa chính tả
      // { label: "Sản phẩm từ sữa", href: "/dairy" },
      // { label: "Bánh mì nướng", href: "/toasts" },
    ],
  },
  {
    title: "Bộ sưu tập",
    links: [
      { label: "Rau củ", href: "/vegetables" },
      { label: "Kem sữa", href: "/cream" },
      { label: "Các sản phẩm từ sữa", href: "/milk" },
      { label: "Trái cây", href: "/fruits" },
      { label: "Thực phẩm lành mạnh", href: "/healthy-food" },
    ],
  },
];
export const services = [
  {
    image: "https://demo-grocy-06.myshopify.com/cdn/shop/files/ser-1.svg?v=1720611244",
    title: "Miễn phí giao hàng cho đơn từ $100",
    link: "#",
  },
  {
    image: "https://demo-grocy-06.myshopify.com/cdn/shop/files/ser-2.svg?v=1720611244",
    title: "Chính sách đổi trả dễ dàng",
    link: "#",
  },
  {
    image: "https://demo-grocy-06.myshopify.com/cdn/shop/files/ser-3.svg?v=1720611244",
    title: "Hoàn tiền 100%",
    link: "#",
  },
];